import { render, staticRenderFns } from "./LoadingWrapper.vue?vue&type=template&id=be434816"
import script from "./LoadingWrapper.vue?vue&type=script&lang=js"
export * from "./LoadingWrapper.vue?vue&type=script&lang=js"
import style0 from "./LoadingWrapper.vue?vue&type=style&index=0&id=be434816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports